import React from 'react';
// @mui
import { Button, IconButton, LinearProgress, Stack, Typography, MenuItem } from '@mui/material';
// utils
import { fDate } from '../../../utils/format-time';
// hooks
import { useResponsive } from '../../../services/hooks';
// components
import Iconify from '../../../components/Iconify';
import CustomPopover, { usePopover } from '../../../components/custom-popover';
import CustomDatePicker from './modals/CustomDatePicker';

// ----------------------------------------------------------------------

const VIEW_OPTIONS = [
  {
    value: 'resourceTimelineMonth',
    label: 'Miesiąc',
    icon: 'mingcute:calendar-month-line'
  },
  {
    value: 'resourceTimelineWeek',
    label: 'Tydzień',
    icon: 'mingcute:calendar-week-line'
  },
  { value: 'resourceTimelineDay', label: 'Dzień', icon: 'mingcute:calendar-day-line' }
  // {
  //   value: 'listWeek',
  //   label: 'Agenda',
  //   icon: 'fluent:calendar-agenda-24-regular'
  // }
];

const ORDER_OPTIONS = [
  {
    value: 'crm_order',
    label: 'Zamówienie wstępne w CRM',
    icon: 'mingcute:document-line'
  }
];

// ----------------------------------------------------------------------

export default function SaleCalendarToolbar({
  date,
  view,
  user,
  loading,
  onNextDate,
  onPrevDate,
  onChangeView
}) {
  const smUp = useResponsive('up', 'sm');
  const popover = usePopover();
  const orderPopover = usePopover();
  const selectedView = VIEW_OPTIONS.filter(item => item.value === view)[0];

  const getTitle = () => {
    if (view == 'resourceTimelineMonth') {
      return fDate(date, 'MMM yyyy');
    } else if (view == 'resourceTimelineWeek' || view == 'listWeek') {
      const firstDayOfWeek = getFirstDayOfWeek(date);
      const dateFuture = date;
      dateFuture.setDate(dateFuture.getDate() + 6);

      return `${fDate(firstDayOfWeek)} - ${fDate(dateFuture)}`;
    }

    return fDate(date);
  };

  function getFirstDayOfWeek(date) {
    const dayOfWeek = date.getDay();
    const diff = date.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    const firstDay = new Date(date.setDate(diff));

    return firstDay;
  }

  const onChangeOrder = () => {
    window.open(`${process.env.REACT_APP_SCENERIO_CRM_URL}employee/forms`);
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: 2.5, pr: 2, position: 'relative' }}
      >
        {smUp && (
          <Button
            size="small"
            color="inherit"
            onClick={popover.onOpen}
            startIcon={<Iconify icon={selectedView.icon} />}
            endIcon={
              <Iconify icon="eva:arrow-ios-downward-fill" sx={{ ml: -0.5 }} />
            }
          >
            {selectedView.label}
          </Button>
        )}

        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton onClick={onPrevDate}>
            <Iconify icon="eva:arrow-ios-back-fill" />
          </IconButton>

          <Typography variant="h6">{getTitle()}</Typography>
          <CustomDatePicker />
          <IconButton onClick={onNextDate}>
            <Iconify icon="eva:arrow-ios-forward-fill" />
          </IconButton>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={1}>
          <Button
            size="small"
            color="inherit"
            onClick={orderPopover.onOpen}
            startIcon={
              <Iconify icon="eva:plus-fill" />
            }
            endIcon={
              <Iconify icon="eva:arrow-ios-downward-fill" sx={{ ml: -0.5 }} />
            }
          >
            {smUp && 'Utwórz'}
          </Button>
        </Stack>

        {loading && (
          <LinearProgress
            color="inherit"
            sx={{
              height: 2,
              width: 1,
              position: 'absolute',
              bottom: 0,
              left: 0
            }}
          />
        )}
      </Stack>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="top-left"
        sx={{ width: 160 }}
      >
        {VIEW_OPTIONS.map(viewOption => (
          <MenuItem
            key={viewOption.value}
            selected={viewOption.value === view}
            onClick={() => {
              popover.onClose();
              onChangeView(viewOption.value);
            }}
          >
            <Iconify icon={viewOption.icon} />
            {viewOption.label}
          </MenuItem>
        ))}
      </CustomPopover>

      <CustomPopover
        open={orderPopover.open}
        onClose={orderPopover.onClose}
        arrow="top-left"
        sx={{ width: 'auto', p: 1 }}
      >
        {ORDER_OPTIONS.map(op => (
          <MenuItem
            key={op.value}
            selected={op.value === user}
            onClick={() => {
              orderPopover.onClose();
              onChangeOrder(op.value);
            }}
          >
            <Iconify icon={op.icon} />
            {op.label}
          </MenuItem>
        ))}
      </CustomPopover>
    </>
  );
}
